import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['input', 'name'];

  showFileName() {
    let files = this.inputTarget.files;
    let names = Array.from(files).map((file) => {
      return file.name;
    });
    this.nameTarget.innerHTML = names.join(', ');
  }
}
